import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications, useFormErrorHandler } from 'core/http';
import { MaintenanceSchema } from 'core/schemas/maintenance';
import { Maintenance } from 'core/types/maintenance';

export default function useMaintenance(id: string) {
  const handleFormErrors = useFormErrorHandler();
  const showErrorNotification = useErrorNotifications();
  const [maintenance, setMaintenance] = useState<Maintenance>();

  useEffect(() => {
    client()
      .get<Maintenance>(`maintenances/${id}`)
      .then(response => response.data)
      .then(setMaintenance)
      .catch(showErrorNotification);
  }, [showErrorNotification, id]);

  const update = useCallback(
    (payload: MaintenanceSchema) => {
      return client()
        .patch<Maintenance>(`maintenances/${id}`, payload)
        .then(response => response.data)
        .then(setMaintenance)
        .catch(handleFormErrors);
    },
    [id, handleFormErrors]
  );

  return { maintenance, update };
}
